<template>
  <div :class=imgName>
  </div>

</template>

<script>
export default {

  data() {
    return {
      imgName : '',
      flag: ''
    };
  },
  mounted() {
    this.isMobile()
  },
  methods:{
    isMobile() {
      this.flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      if (this.flag === null) {
        this.imgName = "home"
      } else {
        this.imgName = "homeMobile"
      }
    }
  }
}
</script>


<style scoped>
.home {
  width: 100%;
  min-height: 100vh;
  background: url("../assets/1688/img/maintenance.png") center center no-repeat;
  background-size: 100% 100%;
}
.homeMobile {
  width: 100%;
  min-height: 100vh;
  background: url("../assets/1688/img/maintenanceMobile.png") center center no-repeat;
  background-size: 100% 100%;
}
/* @import '../assets/awardTW/css/style.css'; */
</style>



// WEBPACK FOOTER //
// src/components/maintenance1688.vue